import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { List, useListRepository } from 'elentari'
import Grid from '@material-ui/core/Grid'
import { downloadCsv } from '../../../../utils/DownloadCsv'
import useQueryFilter from '../../useQueryFilter'
import tarefaSlaRepository from '../../TarefaSlaRepository'
import { TarefaBadgeStatus } from '../../../Tarefa/TarefaStatus'
import tarefaRepository from '../../../Tarefa/tarefaRepository'

const TableViagemAtual = props => {
  const [data, setData] = useState([])
  const [query] = useQueryFilter(props.location.search)

  useEffect(() => {
    async function fetchData() {
      const response = await tarefaSlaRepository.viagensAtual({
        gerenciadora: query.gerenciadora
      })
      if (response.ok) {
        setData(response.data)
      }
    }
    fetchData()
    const interval = setInterval(fetchData, 1000 * 30)
    return () => clearInterval(interval)
  }, [query])

  const onDownloadClick = async () => {
    await downloadCsv(
      data,
      {
        fields: {
          gerenciadora: {
            label: 'Gerenciadora'
          }
        }
      },
      true,
      true,
      'Viagem Atual'
    )
  }

  const listHook = useListRepository({
    repository: tarefaRepository,
    defaultSort: 'createdAt desc',
    path: 'tarefa',
    query: [['status', 'Liberado']]
  })

  const listOptions = {
    defaultOrder: 'createdAt desc',
    fields: {
      id: {
        label: 'SM'
      },
      gerenciadora: {
        label: 'Gerenciadora'
      },
      empresa: {
        label: 'Empresa',
        format: empresa => (empresa ? empresa.sigla : '-'),
        noOrder: true,
        align: 'center'
      },
      status: {
        label: 'Status',
        format: value => <TarefaBadgeStatus status={value} />
      },
      createdAt: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm'),
        align: 'center'
      },
      previsaoEntrega: {
        label: 'Previsão de Entrega',
        format: data => (data ? moment(data).format('DD/MM/YYYY') : '-'),
        align: 'center'
      }
    }
  }

  return (
    <Grid item xs={12}>
      <List
        {...props}
        {...listHook}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickEdit={null}
        onClickNew={null}
        onClickRow={item => props.history.push(`/tarefa/${item.id}`)}
        removeItem={null}
        onDownloadClick={onDownloadClick}
        listOptions={listOptions}
      />
    </Grid>
  )
}

export default React.memo(TableViagemAtual)
